export default "__VITE_ASSET__BhFPSfxk__"